<div class="chip" [class]="{'main':obligated,'light':!obligated}">
  {{(obligated ? 'TRADEMARK.USAGE_OBLIGATION' : 'TRADEMARK.NOT_USAGE_OBLIGATION') | translate}}
</div>